<template>
  <el-select
    :model-value="projectStore.currentProjectId"
    placeholder="请选择项目"
    no-data-text="您没有相关权限"
    class="project-selector"
    popper-class="project-selector-list"
    filterable
    @change="handleProjectChange"
  >
    <el-option
      v-for="item in projectStore.projectList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
      style="max-width: 50vw;"
    />
  </el-select>
</template>

<script setup>
import { useProjectStore } from "@/Store/ProjectStore";

const projectStore = useProjectStore();

function handleProjectChange(id) {
  projectStore.changeCurrentProject(id);
}
</script>

<style lang="scss">
.project-selector {
  .select-trigger {
    height: 50px;
    line-height: 50px;

    .el-input {
      height: 50px;
      line-height: 50px;

      .el-input__wrapper {
        height: 50px;
        line-height: 50px;
        border: 1px solid #efefef;
        box-shadow: none;
        border-radius: 0;
      }
    }
  }

  .el-input__inner {
    padding-left: 5px;
  }
  .el-select .el-input.is-focus .el-input__wrapper {
    box-shadow: none !important;
  }
  .el-select .el-input .el-input__wrapper {
    box-shadow: none !important;
  }
}

.el-select__popper.project-selector-list {
  transform: translateY(-12px);

  .el-popper__arrow {
    display: none;
  }
}
</style>

